import { useTheme } from '@mui/material';
import * as React from 'react';

export const QuestionMarkCircle = () => {
    const theme = useTheme();
    const primaryColour = theme.colors.links.main;

    return (
        <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 8.667C8 7.333 10 8 10 6c0-2-4-2-4 0m8 2A6 6 0 1 1 2 8a6 6 0 0 1 12 0v0Z"
                stroke={primaryColour}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.033 11.333h-.066"
                stroke={primaryColour}
                strokeWidth={1.95}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
